import { useObserver } from "mobx-react";
import { AiOutlineLeft } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import ResumeTable from "./ResumeTable";
import Description from "./Description";
import { useStores } from "../../../store";
import Loader from "../../reusble_components/loader";
import GeneratePopup from "./GeneratePopup";
import { GetMoreCreditsPopUp } from "../../dashboard/basicDetails";
import AlertPopup from "../../signup_2/alertPopup";
import { useRef, useState } from "react";
import AddResumes from "./AddMoreResumes";
import { BsStars } from "react-icons/bs";
import { apiGet, apiPostPut } from "../../../api/api_methods";
import UploadLoader from "../../reusble_components/uploadLoader";
import { createResumeScores } from "../../../api/recruiterResumeScoresApi";

export default function () {
  const navigate = useNavigate();
  const { RecuiterStore, PopupStore, UserStore } = useStores();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let sav = query.get("save");
  const [save, setSave] = useState(sav === "true");
  const jdId = location.pathname.split("/").pop();
  const inputRef = useRef(null);
  const [edit, setEdit] = useState(false);
  const [upload, setUpload] = useState(false);
  const [sort, setSort] = useState(false);
  const [loader, setLoader] = useState(false);
  const [uploadmessage, setUploadMessage] = useState("");

  const handleSort = async () => {
    try {
      if (RecuiterStore.generatedJD === "") {
        setUpload(false);
        PopupStore.setMessage("Please enter Job Description");
        PopupStore.setAlert(true);
        return;
      } else if (RecuiterStore.generatedJD.length < 20) {
        setUpload(false);
        PopupStore.setMessage(
          "Job Description should be atleast 20 characters",
        );
        PopupStore.setAlert(true);
        return;
      }
      setLoader(true);
      setUploadMessage("Updating");
      const response = await apiPostPut(
        { jd: RecuiterStore.generatedJD },
        `/jds/update-jd/${jdId}`,
        "PUT",
      );
      const userCoins = JSON.parse(localStorage.getItem("user"))?.coins || 0;
      if (response.status === 200) {
        setUploadMessage("Sorting");
        const res = await createResumeScores(jdId, { isSort: true });
        if (res.status === 200) {
          const count = RecuiterStore.resumeScore?.data?.resumes?.length;
          const delay = count < 20 ? 20000 : 60000; // 20 seconds or 60 seconds

          await new Promise((resolve) => setTimeout(resolve, delay));

          setUploadMessage("Fetching");
          await new Promise((resolve) => setTimeout(resolve, 10000));
          RecuiterStore.setJDID(jdId);
          RecuiterStore.fetchResumeScore(0);
          navigate(`/company/resumescore/${jdId}`);

          setLoader(false);
          setSave(false);
          setSort(false);
        } else {
          PopupStore.setMessage(
            userCoins >= 5
              ? `You can upload only ${userCoins / 5} resumes`
              : "You don't have enough credits to check the resumes score",
          );
        }
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const [currentPage, setCurrentPage] = useState(0);

  return useObserver(() => {
    return (
      <>
        <UploadLoader
          load={loader}
          save={true}
          count={0}
          len={RecuiterStore.resumeScore?.data?.resumes?.length}
          mess={uploadmessage}
        />
        <AlertPopup close={false} />
        {PopupStore.getMoreCredits && (
          <GetMoreCreditsPopUp
            popUpInitialValue={PopupStore.getMoreCredits}
            handlePopup={() => {
              PopupStore.setGetMoreCredits(false);
            }}
            referAndEarnHide={true}
          />
        )}
        <AddResumes id={jdId} />
        <GeneratePopup />
        <Loader loader={RecuiterStore.loader} />
        {/* <Loader loader={loader} /> */}
        <Loader loader={upload} />
        <div className="flex flex-col gap-4 p-4 md:p-6">
          {/* Job Header Section */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="flex flex-col md:flex-row md:items-center justify-between p-4 md:p-6 bg-gradient-to-r from-gray-50 to-transparent gap-4">
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center justify-between md:justify-start w-full md:w-auto gap-4">
                  <button
                    onClick={() => navigate(-1)}
                    className="p-2 hidden md:block hover:bg-white/80 rounded-xl transition-all duration-200 hover:shadow-sm"
                  >
                    <AiOutlineLeft className="text-lg text-gray-600" />
                  </button>
                  <div className="md:hidden">
                    {save && !sort && (
                      <button
                        onClick={() => setSort(true)}
                        className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-xl hover:bg-primary/90 transition-all duration-200 shadow-sm hover:shadow text-sm font-medium"
                      >
                        Sort now
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-3 md:gap-4 w-full md:w-auto">
                  <input
                    ref={inputRef}
                    defaultValue={
                      RecuiterStore.resumeScore.data?.resumes[0]?.jdName ??
                      RecuiterStore.resumeScore.data?.resumes[0]?.jdId
                    }
                    readOnly={edit}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        if (e.target.value.length === 0) return;
                        RecuiterStore.updatejd(
                          e.target.value,
                          RecuiterStore.resumeScore.data?._id,
                        );
                        setEdit(true);
                      }
                    }}
                    className={`text-base md:text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary/20 py-2.5 px-4 rounded-xl transition-all duration-200 bg-white/60 backdrop-blur-sm w-full md:w-auto md:min-w-[240px] shadow-sm ${
                      edit
                        ? "cursor-pointer hover:bg-white"
                        : "border-2 border-gray-100 hover:border-primary/20"
                    }`}
                  />
                  <div className="flex md:hidden items-center gap-2 bg-white/60 backdrop-blur-sm py-2 px-3 rounded-lg border border-gray-100">
                    <span className="text-sm text-gray-500">Job ID:</span>
                    <span className="text-sm font-medium text-gray-700 font-mono">
                      {RecuiterStore.resumeScore.data?.resumes[0]?.jdId}
                    </span>
                  </div>
                </div>
                <div className="hidden md:flex items-center gap-2 bg-white/60 backdrop-blur-sm py-2 px-3 rounded-lg border border-gray-100">
                  <span className="text-sm text-gray-500">Job ID:</span>
                  <span className="text-sm font-medium text-gray-700 font-mono">
                    {RecuiterStore.resumeScore.data?.resumes[0]?.jdId}
                  </span>
                </div>
              </div>

              <div className="hidden md:block">
                {save && !sort && (
                  <button
                    onClick={() => setSort(true)}
                    className="flex items-center gap-2 bg-primary text-white px-5 py-2.5 rounded-xl hover:bg-primary/90 transition-all duration-200 shadow-sm hover:shadow font-medium"
                  >
                    Sort now
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Rest of the content */}
          {sort && (
            <div className="flex flex-col gap-4">
              <span className="flex font-semibold  flex-row justify-between items-center gap-4">
                <p className="text-lg">Enter your Job Description</p>
                <button
                  className="p-1.5 rounded-xl text-primary font-semibold border border-primary flex items-center gap-2"
                  onClick={() => {
                    RecuiterStore.ClearGenerateParams();
                    PopupStore.setGenerate(true);
                  }}
                >
                  <BsStars />
                  Auto generate
                </button>
              </span>
              <Description />
              <div className="w-full flex justify-end items-center gap-4 font-semibold">
                <button
                  className="bg-primary text-white p-2 rounded-lg ml-2"
                  onClick={() => {
                    handleSort();
                  }}
                >
                  Sort Now
                </button>
              </div>
            </div>
          )}
          {!save && <Description score={true} />}

          <ResumeTable hide={true} sort={sort} setSort={() => setSort(true)} />
          <div className="w-full">
            {/* <button
              className="text-primary font-semibold"
              onClick={() => {
                navigate("/company/resume");
              }}
            >
              Back
            </button> */}
          </div>
        </div>
      </>
    );
  });
}
